import { type_of_use_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateTypeOfUseEnum = (enumValue: type_of_use_enum) => {
  switch (enumValue) {
    case type_of_use_enum.ADMINISTRATIVE_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-ADMINISTRATIVE_BUILDING" />;
    case type_of_use_enum.CAFETERIA:
      return <Trans i18nKey="Enum_TypeOfUseEnum-CAFETERIA" />;
    case type_of_use_enum.CENTRAL_SERVICE_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-CENTRAL_SERVICE_BUILDING" />;
    case type_of_use_enum.COLD_WAREHOUSE:
      return <Trans i18nKey="Enum_TypeOfUseEnum-COLD_WAREHOUSE" />;
    case type_of_use_enum.COMMUNAL_ACCOMMODATION:
      return <Trans i18nKey="Enum_TypeOfUseEnum-COMMUNAL_ACCOMMODATION" />;
    case type_of_use_enum.DATA_CENTER:
      return <Trans i18nKey="Enum_TypeOfUseEnum-DATA_CENTER" />;
    case type_of_use_enum.DOCTOR_OFFICE:
      return <Trans i18nKey="Enum_TypeOfUseEnum-DOCTOR_OFFICE" />;
    case type_of_use_enum.DORM:
      return <Trans i18nKey="Enum_TypeOfUseEnum-DORM" />;
    case type_of_use_enum.EDUCATION_INSTITUTION:
      return <Trans i18nKey="Enum_TypeOfUseEnum-EDUCATION_INSTITUTION" />;
    case type_of_use_enum.ELDERLY_DAYCARE_CENTER:
      return <Trans i18nKey="Enum_TypeOfUseEnum-ELDERLY_DAYCARE_CENTER" />;
    case type_of_use_enum.EVENT_HALL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-EVENT_HALL" />;
    case type_of_use_enum.EXHIBITION_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-EXHIBITION_BUILDING" />;
    case type_of_use_enum.EXHIBITION_HALL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-EXHIBITION_HALL" />;
    case type_of_use_enum.FIRE_DEPARTMENT:
      return <Trans i18nKey="Enum_TypeOfUseEnum-FIRE_DEPARTMENT" />;
    case type_of_use_enum.GYM:
      return <Trans i18nKey="Enum_TypeOfUseEnum-GYM" />;
    case type_of_use_enum.HOTEL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-HOTEL" />;
    case type_of_use_enum.LABORATORY_AND_RESEARCH_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-LABORATORY_AND_RESEARCH_BUILDING" />;
    case type_of_use_enum.LECTURE_AND_TEACHING_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-LECTURE_AND_TEACHING_BUILDING" />;
    case type_of_use_enum.LEISURE_AND_COMMUNITY_FACILITY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-LEISURE_AND_COMMUNITY_FACILITY" />;
    case type_of_use_enum.LIBRARY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-LIBRARY" />;
    case type_of_use_enum.LOGISTIC_STORAGE_OPERATION_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-LOGISTIC_STORAGE_OPERATION_BUILDING" />;
    case type_of_use_enum.MEDICAL_AND_NURSING_FACILITY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-MEDICAL_AND_NURSING_FACILITY" />;
    case type_of_use_enum.MFH:
      return <Trans i18nKey="Enum_TypeOfUseEnum-MFH" />;
    case type_of_use_enum.OUTDOOR_SPORT_FACILITY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-OUTDOOR_SPORT_FACILITY" />;
    case type_of_use_enum.PARKING_GARAGE:
      return <Trans i18nKey="Enum_TypeOfUseEnum-PARKING_GARAGE" />;
    case type_of_use_enum.POLICE_STATION:
      return <Trans i18nKey="Enum_TypeOfUseEnum-POLICE_STATION" />;
    case type_of_use_enum.PRODUCTION_AND_WORKSHOP_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-PRODUCTION_AND_WORKSHOP_BUILDING" />;
    case type_of_use_enum.REHABILITATION_CENTER:
      return <Trans i18nKey="Enum_TypeOfUseEnum-REHABILITATION_CENTER" />;
    case type_of_use_enum.RESTAURANT:
      return <Trans i18nKey="Enum_TypeOfUseEnum-RESTAURANT" />;
    case type_of_use_enum.RETAIL_FOOD:
      return <Trans i18nKey="Enum_TypeOfUseEnum-RETAIL_FOOD" />;
    case type_of_use_enum.RETAIL_NON_FOOD:
      return <Trans i18nKey="Enum_TypeOfUseEnum-RETAIL_NON_FOOD" />;
    case type_of_use_enum.RIDING_AND_ICE_SPORT_HALL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-RIDING_AND_ICE_SPORT_HALL" />;
    case type_of_use_enum.SFH:
      return <Trans i18nKey="Enum_TypeOfUseEnum-SFH" />;
    case type_of_use_enum.SHOPPING_CENTER:
      return <Trans i18nKey="Enum_TypeOfUseEnum-SHOPPING_CENTER" />;
    case type_of_use_enum.SPORT_AND_LEISURE_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-SPORT_AND_LEISURE_BUILDING" />;
    case type_of_use_enum.TRANSPORT_TERMINAL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-TRANSPORT_TERMINAL" />;
    case type_of_use_enum.UNIVERSITY_AND_RESEARCH_INSTITUTION:
      return <Trans i18nKey="Enum_TypeOfUseEnum-UNIVERSITY_AND_RESEARCH_INSTITUTION" />;
    case type_of_use_enum.UTILITY_AND_INFRASTRUCTURE_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-UTILITY_AND_INFRASTRUCTURE_BUILDING" />;
    case type_of_use_enum.UTILITY_SERVICE_BUILDING:
      return <Trans i18nKey="Enum_TypeOfUseEnum-UTILITY_SERVICE_BUILDING" />;
    case type_of_use_enum.VEHICLE_FLEET_FACILITY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-VEHICLE_FLEET_FACILITY" />;
    case type_of_use_enum.VEHICLE_SERVICE_AND_INSPECTION_FACILITY:
      return <Trans i18nKey="Enum_TypeOfUseEnum-VEHICLE_SERVICE_AND_INSPECTION_FACILITY" />;
    case type_of_use_enum.VEHICLE_STORAGE_HALL:
      return <Trans i18nKey="Enum_TypeOfUseEnum-VEHICLE_STORAGE_HALL" />;
    case type_of_use_enum.YOUTH_CENTER:
      return <Trans i18nKey="Enum_TypeOfUseEnum-YOUTH_CENTER" />;
  }
};

export const translateTypeOfUseEnum_dynamic = (enumValue: type_of_use_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case type_of_use_enum.ADMINISTRATIVE_BUILDING:
      return t('Enum_TypeOfUseEnum-ADMINISTRATIVE_BUILDING');
    case type_of_use_enum.CAFETERIA:
      return t('Enum_TypeOfUseEnum-CAFETERIA');
    case type_of_use_enum.CENTRAL_SERVICE_BUILDING:
      return t('Enum_TypeOfUseEnum-CENTRAL_SERVICE_BUILDING');
    case type_of_use_enum.COLD_WAREHOUSE:
      return t('Enum_TypeOfUseEnum-COLD_WAREHOUSE');
    case type_of_use_enum.COMMUNAL_ACCOMMODATION:
      return t('Enum_TypeOfUseEnum-COMMUNAL_ACCOMMODATION');
    case type_of_use_enum.DATA_CENTER:
      return t('Enum_TypeOfUseEnum-DATA_CENTER');
    case type_of_use_enum.DOCTOR_OFFICE:
      return t('Enum_TypeOfUseEnum-DOCTOR_OFFICE');
    case type_of_use_enum.DORM:
      return t('Enum_TypeOfUseEnum-DORM');
    case type_of_use_enum.EDUCATION_INSTITUTION:
      return t('Enum_TypeOfUseEnum-EDUCATION_INSTITUTION');
    case type_of_use_enum.ELDERLY_DAYCARE_CENTER:
      return t('Enum_TypeOfUseEnum-ELDERLY_DAYCARE_CENTER');
    case type_of_use_enum.EVENT_HALL:
      return t('Enum_TypeOfUseEnum-EVENT_HALL');
    case type_of_use_enum.EXHIBITION_BUILDING:
      return t('Enum_TypeOfUseEnum-EXHIBITION_BUILDING');
    case type_of_use_enum.EXHIBITION_HALL:
      return t('Enum_TypeOfUseEnum-EXHIBITION_HALL');
    case type_of_use_enum.FIRE_DEPARTMENT:
      return t('Enum_TypeOfUseEnum-FIRE_DEPARTMENT');
    case type_of_use_enum.GYM:
      return t('Enum_TypeOfUseEnum-GYM');
    case type_of_use_enum.HOTEL:
      return t('Enum_TypeOfUseEnum-HOTEL');
    case type_of_use_enum.LABORATORY_AND_RESEARCH_BUILDING:
      return t('Enum_TypeOfUseEnum-LABORATORY_AND_RESEARCH_BUILDING');
    case type_of_use_enum.LECTURE_AND_TEACHING_BUILDING:
      return t('Enum_TypeOfUseEnum-LECTURE_AND_TEACHING_BUILDING');
    case type_of_use_enum.LEISURE_AND_COMMUNITY_FACILITY:
      return t('Enum_TypeOfUseEnum-LEISURE_AND_COMMUNITY_FACILITY');
    case type_of_use_enum.LIBRARY:
      return t('Enum_TypeOfUseEnum-LIBRARY');
    case type_of_use_enum.LOGISTIC_STORAGE_OPERATION_BUILDING:
      return t('Enum_TypeOfUseEnum-LOGISTIC_STORAGE_OPERATION_BUILDING');
    case type_of_use_enum.MEDICAL_AND_NURSING_FACILITY:
      return t('Enum_TypeOfUseEnum-MEDICAL_AND_NURSING_FACILITY');
    case type_of_use_enum.MFH:
      return t('Enum_TypeOfUseEnum-MFH');
    case type_of_use_enum.OUTDOOR_SPORT_FACILITY:
      return t('Enum_TypeOfUseEnum-OUTDOOR_SPORT_FACILITY');
    case type_of_use_enum.PARKING_GARAGE:
      return t('Enum_TypeOfUseEnum-PARKING_GARAGE');
    case type_of_use_enum.POLICE_STATION:
      return t('Enum_TypeOfUseEnum-POLICE_STATION');
    case type_of_use_enum.PRODUCTION_AND_WORKSHOP_BUILDING:
      return t('Enum_TypeOfUseEnum-PRODUCTION_AND_WORKSHOP_BUILDING');
    case type_of_use_enum.REHABILITATION_CENTER:
      return t('Enum_TypeOfUseEnum-REHABILITATION_CENTER');
    case type_of_use_enum.RESTAURANT:
      return t('Enum_TypeOfUseEnum-RESTAURANT');
    case type_of_use_enum.RETAIL_FOOD:
      return t('Enum_TypeOfUseEnum-RETAIL_FOOD');
    case type_of_use_enum.RETAIL_NON_FOOD:
      return t('Enum_TypeOfUseEnum-RETAIL_NON_FOOD');
    case type_of_use_enum.RIDING_AND_ICE_SPORT_HALL:
      return t('Enum_TypeOfUseEnum-RIDING_AND_ICE_SPORT_HALL');
    case type_of_use_enum.SFH:
      return t('Enum_TypeOfUseEnum-SFH');
    case type_of_use_enum.SHOPPING_CENTER:
      return t('Enum_TypeOfUseEnum-SHOPPING_CENTER');
    case type_of_use_enum.SPORT_AND_LEISURE_BUILDING:
      return t('Enum_TypeOfUseEnum-SPORT_AND_LEISURE_BUILDING');
    case type_of_use_enum.TRANSPORT_TERMINAL:
      return t('Enum_TypeOfUseEnum-TRANSPORT_TERMINAL');
    case type_of_use_enum.UNIVERSITY_AND_RESEARCH_INSTITUTION:
      return t('Enum_TypeOfUseEnum-UNIVERSITY_AND_RESEARCH_INSTITUTION');
    case type_of_use_enum.UTILITY_AND_INFRASTRUCTURE_BUILDING:
      return t('Enum_TypeOfUseEnum-UTILITY_AND_INFRASTRUCTURE_BUILDING');
    case type_of_use_enum.UTILITY_SERVICE_BUILDING:
      return t('Enum_TypeOfUseEnum-UTILITY_SERVICE_BUILDING');
    case type_of_use_enum.VEHICLE_FLEET_FACILITY:
      return t('Enum_TypeOfUseEnum-VEHICLE_FLEET_FACILITY');
    case type_of_use_enum.VEHICLE_SERVICE_AND_INSPECTION_FACILITY:
      return t('Enum_TypeOfUseEnum-VEHICLE_SERVICE_AND_INSPECTION_FACILITY');
    case type_of_use_enum.VEHICLE_STORAGE_HALL:
      return t('Enum_TypeOfUseEnum-VEHICLE_STORAGE_HALL');
    case type_of_use_enum.YOUTH_CENTER:
      return t('Enum_TypeOfUseEnum-YOUTH_CENTER');
  }
};
